<script>
import EffConOrderFormDialog from "../../Dialog/EffConOrderFormDialog.vue";
import {mapGetters, mapState} from "vuex";
import getMixin from "../../mixins/getMixin";
import toControllerMixin from "../../mixins/toControllerMixin";
import dataMixin from "../../mixins/dataMixin";
import EffectiveContractAccessTable from "../components/OrderPage/EffectiveContractAccessTable.vue";

export default {
  name: "EffectiveContractsOrderFormPage",

  components: {EffectiveContractAccessTable, EffConOrderFormDialog},

  mixins: [getMixin, toControllerMixin, dataMixin],

  computed: {
    ...mapState({
      orderPresent: state => state.effective_contract.orderPresent,
    }),

    ...mapGetters({
      isAdmin: "effective_contract/isAdmin",
      isUMUManager: "effective_contract/isUMUManager",
    }),
  },

  methods: {
    goEffContractTeacher() {
      this.$router.push('/effective_contracts/app/')
    }
  }
}
</script>

<template>
  <div>
    <v-sheet>
      <h4 class="text-h5">Заполнение информации</h4>
    </v-sheet>
    <v-sheet min-height="60vh" width="100%"  class="d-flex justify-center align-center">
      <v-row>
        <v-col  cols="12" lg="5">
          <EffConOrderFormDialog
            :dialog="true"
            @save-data="goEffContractTeacher"
          />
        </v-col>
        <v-divider vertical/>
        <v-col cols="12" lg="7">
          <v-sheet>
            <h4 class="text-h5">Требуемые показатели для заполнения</h4>
          </v-sheet>
          <effective-contract-access-table/>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<style scoped>

</style>